import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormArray } from '@angular/forms';
import { ActivatedRoute, Router } from "@angular/router";
import { loadingFade } from '../../animacoes';

import { MarcaVeiculoService } from '../services/marca-veiculo.service';
import { ModeloVeiculoService } from '../services/modelo-veiculo.service';
import { TipoDespesaService } from '../services/tipo-despesa.service';
import { ModeloVeiculoTipoDespesaService } from '../services/modelo-veiculo-tipo-despesa.service';

@Component({
  selector: 'app-modelo-veiculo-manutencao',
  templateUrl: './modelo-veiculo-manutencao.component.html',
  styleUrls: ['./modelo-veiculo-manutencao.component.css'],
  animations: [loadingFade]
})
export class ModeloVeiculoManutencaoComponent implements OnInit {
	public loading;
	public submitting = false;
	public modelo_veiculo_id = null;

	public formModeloVeiculo: FormGroup;
	public formModeloVeiculoManutencao: FormGroup;
	public tipo_despesa_array = [];
	public modelo_veiculo_tipo_despesa_array = [];  
  
  	constructor(
		private route: ActivatedRoute,
		private fb: FormBuilder,
		private marcaVeiculoSvc: MarcaVeiculoService,
		private modeloVeiculoSvc: ModeloVeiculoService,
		private tipoDespesaSvc: TipoDespesaService,
		private ModeloVeiculoTipoDespesaSvc: ModeloVeiculoTipoDespesaService,
		private router: Router) { }

  	ngOnInit() {
		this.criaForm(); 
		this.criaLista();
		this.loading = true;
		
		this.route.params.subscribe( params => {
			if (params.id) {
				this.modelo_veiculo_id = params.id;
				// pega dados a partir do id
				this.modeloVeiculoSvc.getModeloVeiculo(params.id).then((data: any) => {

					this.marcaVeiculoSvc.getMarcaVeiculo(data.marca_veiculo_id).then((dados: any) => {

						this.preencheForm({
							modelo_veiculo_id: data.modelo_veiculo_id,
							modelo_veiculo_nome: data.modelo_veiculo_nome,
							marca_veiculo_nome: dados.marca_veiculo_nome
						});
						this.loading = false;
					});
				});
				this.pegaModeloVeiculoTiposDespesas(params.id);
			}
			else {
				this.loading = false;
			}
		});
		
  	}

  	criaForm() {
		this.formModeloVeiculo = this.fb.group({
			modelo_veiculo_id: null,
			modelo_veiculo_nome: [''],
			marca_veiculo_nome: ['']
		});
		
		this.pegaTipoDespesas();
	}

	criaLista(){
		this.formModeloVeiculoManutencao = this.fb.group({
			manutencoes: this.fb.array([])
		});
	}

	pegaTipoDespesas() {
		this.tipoDespesaSvc.getTiposDespesa('tipo_despesa_nome').then((data: any[]) => {
			this.tipo_despesa_array = data;
		}).catch((err) => {
			console.log(err);
		});
	}

	preencheForm(dados) {
		this.formModeloVeiculo.setValue(dados);
	}

	enviaModeloVeiculoManutencao() {
		if (this.formModeloVeiculoManutencao.valid) {
			let toSend = this.formModeloVeiculoManutencao.value;
			if(toSend['manutencoes'].length > 0){
				this.ModeloVeiculoTipoDespesaSvc.limpaModeloVeiculoTipoDesepesa(parseInt(this.modelo_veiculo_id));
				this.submitting = true;
				for(let manutencao in toSend['manutencoes']){
					toSend['manutencoes'][manutencao]['modeloId'] = parseInt(this.modelo_veiculo_id);
					toSend['manutencoes'][manutencao]['sequencia'] = 0;
					this.ModeloVeiculoTipoDespesaSvc.criaModeloVeiculoTipoDesepesa(toSend['manutencoes'][manutencao]).then((data) => {
						console.log('resp', data);
					}).catch(err => {
						console.log(err);
					});
				}
				this.router.navigate(['home/modelosveiculo']);
			}
		}
	}

	createManutencao(despesa = null, kmPrevisao = null, tempoPrevisao = null){
		return this.fb.group({
			despesa: [despesa, [Validators.required]],
			kmPrevisao: [kmPrevisao, [Validators.required]],
			tempoPrevisao: [tempoPrevisao, [Validators.required]]
		})
	}

	pegaModeloVeiculoTiposDespesas(modeloId) {
		this.modelo_veiculo_tipo_despesa_array = [];
		this.loading = true;
		this.ModeloVeiculoTipoDespesaSvc.getModeloVeiculoTipoDesepesa(modeloId).then((data: any[]) => {
			this.modelo_veiculo_tipo_despesa_array = data;
			this.loading = false;
			if(this.modelo_veiculo_tipo_despesa_array.length > 0){
				for (let item of this.modelo_veiculo_tipo_despesa_array){
					this.addRow(item.tipo_despesa_id, item.quilometragem_previsao, item.intervalo_meses_previsao);
				}
			}
			else{
				this.addRow();
			}
		}).catch((err) => {
			console.log(err);
			this.loading = false;
		})
	}

	addRow(despesa = null, kmPrevisao = null, tempoPrevisao = null){
		const manutencoes = this.formModeloVeiculoManutencao.get('manutencoes') as FormArray;
		if(despesa != null && kmPrevisao != null && tempoPrevisao != null){
			manutencoes.push(this.createManutencao(despesa, kmPrevisao, tempoPrevisao));
		}
		else{
			manutencoes.push(this.createManutencao());
		}
	}

	removeRow(index){
		const manutencoes = this.formModeloVeiculoManutencao.get('manutencoes') as FormArray;
		manutencoes.removeAt(index);
	}

	invalid(nome) {
		let input = this.formModeloVeiculoManutencao.get(nome);
		return input.touched && input.invalid;
	}

}
